(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".video__btn-play").on("click", function (e) {
      e.preventDefault();
      $('body').addClass('overlay-active');
      $(".video-container, .video-wrapper, .pop-up__video-close , .video-popup").css('display','flex');
      var srchref = "",
          autoplay = "",
          id = $(this).data("id");
      if ($(this).data("type") == "vimeo")
        var srchref = "//player.vimeo.com/video/";
      else if ($(this).data("type") == "youtube")
        var srchref = "https://www.youtube.com/embed/";
      if ($(this).data("autoplay") == true) autoplay = "?autoplay=1";
      $("#video-popup-iframe").attr("src", srchref + id + autoplay);
      $("#video-popup-iframe").on("load", function () {
        $(".video-wrapper").show();
      });
    });

    $(".pop-up__video-close").on("click", function (e) {
       $('body').removeClass('overlay-active');
      $(".video-container, .video-wrapper, .pop-up__video-close , .video-popup").css('display','none');
      $("#video-popup-iframe").attr("src", "");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
